import { encode, decode } from 'js-base64';

export const hashMixin = {
    props: {
        enableHash: {
            type: Boolean,
            default: true,
        },
    },
    methods: {

        saveToHash(id, model, history = true) {
            if (!this.enableHash) {
                return;
            }

            let modelFromHash = this.getFromHash() || {};

            if (!Object.entries(model).length) {
                delete modelFromHash[id];
            } else {
                modelFromHash[id] = model;
            }

            if (!Object.entries(modelFromHash).length) {
                window.location.hash = '';
                return;
            }
            var json = JSON.stringify(modelFromHash);
            var base64 = encode(json);

            if (history) {
                window.location.hash = base64;
            } else {
                if (window.location.hash) {
                    window.location.replace(window.location.href.replace(/#.*/, `#${base64}`))
                } else {
                    window.location.replace(`${window.location.href}#${base64}`)
                }
            }

        },
        getFromHash() {
            let hash = window.location.hash;
            if (!hash || hash.length == 1) {
                return null;
            }

            let jsonString = decode(hash.substring(1));
            return JSON.parse(jsonString);
        },
    }
};